import Vue from 'vue'
import { Context } from '@nuxt/types'
import { logger } from '@ustra/core'
import { localStorage } from '@ustra/core/src/utils/storage/local-storage'
import errorEventBus from '@ustra/nuxt/src/vue/event-bus/global/error-event-bus'
import authEventBus from '@ustra/nuxt/src/vue/event-bus/global/auth-event-bus'
import { IS_AUTO_LOGIN } from '@hds/help-common/src/store/modules/storage-key'
import * as commonUtils from '../utils/common-utils'
import * as apiUrls from '../utils/api-urls'
import pushSettingEventBus from '~/event-bus/push-setting-event-bus'
import userService from '../service/co/user-service'

export class HdhsHelpPlugin {
  private context: Context = null

  constructor(context: Context) {
    this.context = context
    this.init()
  }

  private init() {}

  /**
   * Store
   */
  public store = {}

  /**
   * Common Utils
   */
  get utils() {
    return commonUtils
  }

  /**
   * API URL
   */
  get urls() {
    return apiUrls
  }
}

export default (context: Context) => {
  const $ustra = context.$ustra
  $ustra.hp = new HdhsHelpPlugin(context)

  // Back Key
  $ustra.mobile.bridge.addNativeListener('IF_BACK', (param) => {
    // 인터페이스 수신 처리 수행
    if ($ustra.modal.store.currentModalComponent) {
      $ustra.modal.store.currentModalComponent.hide()
      return
    }

    if ($ustra.router.histories.length > 1) $ustra.router.back()
    else {
      // 앱 종료 처리
      // djyoo 21.08.13
      param.data.finish = true
      return param.data
    }
  })

  // djyoo 21.08.13 App Common event 수신 등록
  $ustra.mobile.bridge.addNativeListener('IF_COMMON_IN', (param) => {
    const type = param.data?.type
    console.log('IF_COMMON_IN 호출', type)
    if (type === '01') {
      // Push 설정 페이지 호출
      pushSettingEventBus.emit({ type: 'native' })
      param.data.success = true
    } else if (type === '02') {
      // 로그아웃
      $ustra.auth.logout()
      param.data.success = true
    } else if (type === '03') {
      // 자동로그인 on/off
      const onOff = param.data?.onOff
      console.log('자동로그인 onOff 호출', onOff)

      localStorage.setItem(IS_AUTO_LOGIN, onOff)
      param.data.success = true
    } else if (type === '04') {
      // 설정 정보 (아이디, 자동로그인 여부) 요청 응답
      param.data.userId = $ustra.hs.store.auth.currentUser.userId
      param.data.venCd = $ustra.hs.store.auth.currentUser.venCd
      param.data.ven2Cd = $ustra.hs.store.auth.currentUser.ven2Cd
      param.data.autoLogin = localStorage.getItem(IS_AUTO_LOGIN)
      param.data.success = true
    } else if (type === '05') {
      // web reset 요청
      console.log('Web reset 요청')

      localStorage.clearItem()
      param.data.success = true
    }

    return param.data
  })

  // 전역 에러 처리
  errorEventBus.on((state) => {
    // logger().info({
    //   message: '전역 Error 처리',
    //   args: [state],
    // })

    const e = state.err

    if (e.name === 'HttpNetworkError') context.error({ statusCode: 504 })
    else if (e.name === 'InvalidAccessError') context.error({ statusCode: 403 })
    else context.error({ statusCode: 500 })
  })

  // 토큰 만료 시 에러 페이지 이동
  authEventBus.on((state) => {
    // logger().info({
    //   message: '인증 Error 처리',
    //   args: [state],
    // })

    if (state.failureType === 'check') return
    if (state.logout) return
    if (state.apiUrl === '/api/auth/logout') {
      state.callback()
      return
    }

    Vue.nextTick(() => {
      setTimeout(async () => {
        const result = await userService.getTokenStatus($ustra.hs.store.cmData.refreshToken)

        if (result.msgCd === '1000') {
          // 동시 접속 만료
          context.error({ statusCode: 401, message: 'DUPLICATION' })
        } else if (result.msgCd === '9999') {
          // 토큰 기간 만료
          context.error({ statusCode: 401, message: 'INVALID' })
        } else {
          // 토큰 상태가 정상인데 인증 만료가 발생한 경우
          context.error({ statusCode: 500 })
        }
      }, 0)
    })
  })
}
